import { Component, HostListener, Input, OnInit, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { AttachmentsHandler } from '../../../attachments-handler/src/lib/attachments-handler';
import { OpenerWatchdogService } from '../../../attachments-handler/src/lib/services/opener-watchdog.service';
import { SessionExpiredService } from '../../../attachments-handler/src/lib/services/session-expired.service';
import { NavigationGuardService } from '../../../attachments-handler/src/lib/services/navigation-guard.service';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet],
  template: '<router-outlet />',
})
export class Root {}

@Component({
  selector: 'app-main',
  imports: [AttachmentsHandler],
  templateUrl: './app.html',
  styleUrl: './app.scss',
})
export class App implements OnInit {
  private readonly navigationGuard = inject(NavigationGuardService);
  readonly watchdog = inject(OpenerWatchdogService);
  readonly sessionExpired = inject(SessionExpiredService);

  @Input() path = '';

  ngOnInit(): void {
    this.navigationGuard.register();
    this.watchdog.check();
  }

  @HostListener('document:click')
  @HostListener('document:keydown', ['$event'])
  onUserInteraction(e?: KeyboardEvent): void {
    this.watchdog.check();
    if (e) this.blockReloadKeys(e);
  }

  private blockReloadKeys(e: KeyboardEvent): void {
    const isReload = e.key === 'F5' || (e.ctrlKey && e.key === 'r') || (e.metaKey && e.key === 'r');
    if (isReload && this.navigationGuard.isUploading()) e.preventDefault();
  }
}
